<template>
  <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left">
    <template #trigger>
      <button
        class="button"
        :class="{
          'is-success': invoice && invoice.status === 'emitted',
          'is-danger':
            invoice &&
            [
              'rejected',
              'error',
              'ncm-missing',
              'nf-serie-not-configured'
            ].includes(invoice.status),
          'is-dark':
            invoice && ['cancelled', 'unusedNumber'].includes(invoice.status),
          'is-warning': invoice && invoice.status === 'pending'
        }"
        :disabled="
          invoice && ['notSent', 'notEnabled'].includes(invoice.status)
        "
        slot="trigger"
      >
        {{
          invoice.status === "notSent"
            ? "Não enviada"
            : invoice.status === "emitted"
            ? "Emitida"
            : invoice.status === "rejected"
            ? "Rejeitada"
            : invoice.status === "pending"
            ? "Pendente"
            : invoice.status === "error"
            ? "Erro"
            : invoice.status === "cancelled"
            ? "Cancelada"
            : invoice.status === "notEnabled"
            ? "Não habilitada"
            : invoice.status === "ncm-missing"
            ? "Faltando NCM"
            : invoice.status === "nf-serie-not-configured"
            ? "Faltando número de série"
            : invoice.status === "unusedNumber"
            ? "Inutilizada"
            : "-"
        }}
      </button>
    </template>

    <b-dropdown-item
      @click="copyContent(sefazMessage, 'Mensagem do emissor copiada!')"
      aria-role="listitem"
    >
      <b>Mensagem de Erro: </b>{{ sefazMessage }}
      <b-icon icon="copy"></b-icon>
    </b-dropdown-item>

    <b-dropdown-item
      @click="copyContent(transactionId, 'ID da transação copiado!')"
      aria-role="listitem"
    >
      <b>Transaction ID: </b>{{ transactionId }}
      <b-icon icon="copy"></b-icon>
    </b-dropdown-item>

    <b-dropdown-item
      @click="copyContent(invoice.uuid, 'UUID copiado!')"
      aria-role="listitem"
    >
      <b>UUID: </b>{{ invoice.uuid }}
      <b-icon icon="copy"></b-icon>
    </b-dropdown-item>

    <b-dropdown-item
      v-if="merchantReference"
      @click="copyContent(merchantReference, 'Texto copiado!')"
      aria-role="listitem"
    >
      <b>Adyen: </b>{{ merchantReference }}
      <b-icon icon="copy"></b-icon>
    </b-dropdown-item>

    <b-dropdown-item
      v-if="invoice.nfSerie && invoice.nfNumber"
      aria-role="listitem"
      @click="
        copyContent(
          `Nº ${invoice.nfNumber} | Série ${invoice.nfSerie}`,
          'NF copiada!'
        )
      "
    >
      <b>{{ invoiceType }}: </b
      >{{ `Nº ${invoice.nfNumber} | Série ${invoice.nfSerie}` }}
      <b-icon icon="copy"></b-icon>
    </b-dropdown-item>

    <b-dropdown-item>
      <b-button
        v-if="invoice.status === 'emitted'"
        @click="$emit('download-nf', { transactionId, type: 'xml' })"
        type="is-success"
        >Download XML</b-button
      >

      <b-button
        v-if="invoice.status === 'emitted'"
        style="margin-left: 10px"
        @click="$emit('download-nf', { transactionId, type: 'pdf' })"
        type="is-success"
        >Download PDF</b-button
      >
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { common } from "../../../mixins/common";

export default {
  mixins: [common],

  props: ["invoice", "transactionId", "merchantReference", "status"],

  methods: {},

  computed: {
    invoiceType() {
      if (this.invoice) {
        if (this.invoice.invoiceType === "55") return "NF";
        else return "Cupom Fiscal";
      }

      return "";
    },

    sefazMessage() {
      if (this.invoice.status !== "error") return "-";

      if (
        this.invoice.nfeio &&
        this.invoice.nfeio.response &&
        this.invoice.nfeio.response.error &&
        this.invoice.nfeio.response.error.errors &&
        this.invoice.nfeio.response.error.errors.length > 0
      ) {
        let message = "";
        this.invoice.nfeio.response.error.errors.forEach(e => {
          message += `${e.message}\n`;
        });
        if (message != "") return message;
      }

      if (
        this.invoice.nfeio &&
        this.invoice.nfeio.webhooks &&
        this.invoice.nfeio.webhooks.length > 0 &&
        this.invoice.nfeio.webhooks[0].lastEvents.events.length > 0
      ) {
        if (
          this.invoice.nfeio.webhooks[0].lastEvents.events[0].data.message &&
          this.invoice.nfeio.webhooks[0].lastEvents.events[0].data.message.trim() !=
            ""
        )
          return this.invoice.nfeio.webhooks[0].lastEvents.events[0].data
            .message;
        else if (
          this.invoice.nfeio.webhooks[0].lastEvents.events[0].data.messages &&
          this.invoice.nfeio.webhooks[0].lastEvents.events[0].data.messages
            .length > 0
        )
          return this.invoice.nfeio.webhooks[0].lastEvents.events[0].data
            .messages[0];
      }

      return "-";
    }
  }
};
</script>
